require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-are-package-management-systems.json") })
        }
      }, "path---blog-what-are-package-management-systems");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-are-package-management-systems!./.cache/json/blog-what-are-package-management-systems.json
// module id = 1126
// module chunks = 231608221292675